export default __webpack_public_path__ + "static/media/ekincarefulllogo.15757f7b.svg";